{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Šabloni",
    "DESCRIPTION": "Pregledajte šablone poruka sinhronizovane iz vaših WhatsApp sandučića. Da biste napravili ili izmenili šablon, upravljajte njime kod svog provajdera.",
    "COUNT": "Broj šablona: {n}",
    "LEARN_MORE": "Saznajte više o WhatsApp šablonima",
    "SYNC_TEMPLATES": "Sinhronizuj šablone",
    "SYNC_SUCCESS": "Sinhronizacija šablona je pokrenuta za sve WhatsApp sandučiće. Ažuriranja mogu potrajati nekoliko minuta.",
    "PARTIAL_SYNC_ERROR": "Sinhronizacija šablona je pokrenuta za neke WhatsApp sandučiće, ali druge nije bilo moguće sinhronizovati.",
    "SYNC_ERROR": "Nije bilo moguće pokrenuti sinhronizaciju šablona. Molim vas pokušajte ponovo.",
    "SEARCH_PLACEHOLDER": "Pretraži po sadržaju ili imenu...",
    "MANAGE_IN_META": "Upravljaj u Meta",
    "LOADING": "Učitavanje WhatsApp šablona...",
    "EMPTY": "Nijedan WhatsApp šablon nije pronađen.",
    "NO_RESULTS": "Nijedan šablon ne odgovara vašim filterima.",
    "FETCH_ERROR": "Nije bilo moguće učitati WhatsApp šablone. Molim vas pokušajte ponovo.",
    "PARTIAL_FETCH_ERROR": "Neke WhatsApp šablone nije bilo moguće učitati. Molim vas pokušajte ponovo.",
    "LAST_SYNC_ATTEMPT": "Poslednji pokušaj sinhronizacije: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nije poslat na odobrenje u WhatsApp-u"
    },
    "FILTERS": {
      "ALL_INBOXES": "Svi sandučići",
      "ALL_LANGUAGES": "Svi jezici",
      "ALL_TYPES": "Svi tipovi"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Slika",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Poziv na akciju",
      "COPY_CODE": "Kopiraj kod"
    },
    "PREVIEW": {
      "TITLE": "Pregled šablona",
      "DESCRIPTION": "Pogledajte kako ovaj šablon izgleda u WhatsApp-u.",
      "OPEN": "Pregledaj {name}",
      "CLOSE": "Zatvori pregled",
      "DETAILS": "Detalji šablona",
      "STATUS": "Status",
      "TYPE": "Tip sadržaja",
      "CATEGORY": "Kategorija",
      "LANGUAGE": "Jezik",
      "INBOXES": "Sandučići"
    }
  }
}
